// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 419) return "static/css/419.1f94a0116067c7784c23.lib.css";
	if (chunkId === 196) return "static/css/196.c1303040dd380d5f4242.css";
	// return url for filenames based on template
	return undefined;
};